import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputSelectSF from '../../../widgets/form/InputSelectSF'
import InputTextSF from '../../../widgets/form/InputTextSF'

const EMIracker2ReasonUpdateModalUI = ({
  context, successMsg, errorList, setErrorList,
  updateMode, submitted, onSubmit, onCancelClick,
  reason, onReasonChange, reasonError, setReasonError
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Change Reason'
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >

    <InputTextSF reason='select' name='reason' label='Reason'
      value={reason} onChange={onReasonChange} 
      error={reasonError} setError={setReasonError}
    />
  </ModalFormUI>

export default EMIracker2ReasonUpdateModalUI
